// Reads that need the order lock (currently /distributions) fail while another
// request holds it. The backend surfaces that conflict as a 412, or as a 500
// when it happens inside the transaction (TRAIN-2238: order YOC-2607-BQHD,
// "GET /distributions" -> 500 at 18:35:40 while /complete was 412-looping).
//
// The holder is not observable from the frontend — it can be another tab, or
// Swish's own server-to-server callback hitting /complete (UA "Swish" in the
// same logs). So the lock cannot be predicted, only waited out: these reads are
// idempotent GETs, and retrying is the only thing that actually helps.
//
// 4 attempts x 2s covers the ~7s /complete retry loop seen in the logs, and
// costs nothing on the normal path where the first attempt succeeds.
const LOCK_RETRY_ATTEMPTS = 4;
const LOCK_RETRY_DELAY_MS = 2000;
const LOCK_RETRY_STATUSES = [412, 500];

const waitForLockRetry = (delayMs) =>
  new Promise((resolve) => {
    setTimeout(resolve, delayMs);
  });

export const retryOnLockConflict = async (
  request,
  {
    attempts = LOCK_RETRY_ATTEMPTS,
    delayMs = LOCK_RETRY_DELAY_MS,
    onRetry,
  } = {}
) => {
  for (let attempt = 1; ; attempt += 1) {
    try {
      return await request();
    } catch (error) {
      const status = error?.response?.status;

      if (attempt >= attempts || !LOCK_RETRY_STATUSES.includes(status)) {
        throw error;
      }

      if (onRetry) {
        onRetry({ error, attempt, delayMs });
      }

      await waitForLockRetry(delayMs);
    }
  }
};
